






























import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class App extends Vue {
    public toggleMessage: string = "Or sign / verify a message";
    public showMessageButtons: boolean = false;

    public toggle(): void {
        this.showMessageButtons = !this.showMessageButtons;
        this.showMessageButtons
            ? (this.toggleMessage = "Or generate / import a wallet")
            : (this.toggleMessage = "Or sign / verify a message");
    }
}
